module.exports = __webpack_public_path__ + "static/section1-photo1-b3ee8036865573ceeb3770b2f17730eb.png";